import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatDate } from '../../../../utils/dateUtils';

// COMPONENT
const MonitoredDocumentVersionListItem = ({
    s3Version,
    docId,
    isValidated,
    updated,
    created,
    backLink,
}) => (
    <Link
        to={{
            pathname: `/monitored-document/${docId}/version/${s3Version}`,
            state: {
                backLink: backLink,
            },
        }}
        className="list-group-item-action"
    >
        <div className="container">
            <div className="row">
                <div className="col-sm">
                    <strong>{updated ? formatDate(updated) : formatDate(created)}</strong>
                </div>
                <div className="col-sm text-right">
                    {isValidated ? (
                        <span className="badge badge-success">Validated</span>
                    ) : (
                        <span className="badge badge-danger">Not Validated</span>
                    )}
                </div>
            </div>
        </div>
    </Link>
);

MonitoredDocumentVersionListItem.propTypes = {
    docId: PropTypes.string.isRequired,
    s3Version: PropTypes.string.isRequired,
    isValidated: PropTypes.bool.isRequired,
    created: PropTypes.number.isRequired,
    updated: PropTypes.number,
    backLink: PropTypes.string,
};

export default MonitoredDocumentVersionListItem;
